
const config = {
  enter: 2,
  fontSizeUnit: 'pt',
  zIndex: 999999,
  heightMin: 100,
  toolbarButtons: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        '|',
        'textColor',
        'backgroundColor',
        '|',
        'formatUL',
        'formatOL',
        '|',
        'align'
      ],
      buttonsVisible: 18
    },
    moreParagraph: {
      buttons: [],
      buttonsVisible: 1
    },
    moreRich: {
      buttons: [],
      buttonsVisible: 1
    },
    moreMisc: {
      buttons: [],
      align: 'right',
      buttonsVisible: 0
    }
  },
  pastePlain: true,
  imagePaste: false,
  pasteDeniedTags: ['div', 'span', 'p'],
  htmlAllowComments: false,
  htmlAllowedAttrs: [
    'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
    'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
    'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
    'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
    'target', 'title', 'type', 'value', 'valign', 'width'
  ],
  tableEditButtons: [
    'tableRemove',
    'tableRows',
    'tableColumns',
    'tableBorder',
    'tableBackground',
    '-',
    'tableCells',
    'tableCellBackground',
    'tableCellBorder',
    'tableCellHorizontalAlign'
  ],
}

export default config
